class LiveChat extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('click', this.loadChat.bind(this))
  }

  loadChat() {
    const helpButton = document.querySelector('#chat-widget-container')
    // helpButton && helpButton.click()
    if (helpButton.classList.contains("pdp-active")) {
      helpButton.classList.remove("pdp-active");
    } else {
      helpButton.classList.add("pdp-active");
    }
    LiveChatWidget && LiveChatWidget.call("maximize")
  }

}

customElements.define("live-chat", LiveChat)
